import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { ChartListItem } from "interfaces/chart";

export interface ChartListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: ChartListItem[];
}

interface FetchChartListResponse {
  loading: boolean;
  error: boolean;
  response?: ChartListResponse;
  refetch(): Promise<ChartListResponse>;
}

/** Provides a callback which can be used to save a chart in the API */
export const useGetChartsList = (): {
  loading: boolean;
  error: boolean;
  chartsList: ChartListItem[];
  count: number;
  refetchChartsList(): Promise<ChartListResponse>;
} => {
  const {
    loading,
    error,
    response = { results: [], next: null, previous: null, count: 0 },
    refetch
  }: FetchChartListResponse = useFetchGetV2("charts");

  return {
    loading,
    error,
    chartsList: response.results,
    refetchChartsList: refetch,
    count: response.count
  };
};
